import * as React from 'react';

import { ServiceType, CardExtraFilter, CardExtraVariant } from '../types';
import { useCardExtra } from '../hooks';

import { CardExtraProvider } from './CardExtra.context';
import CardExtraSummary from './CardExtraSummary/CardExtraSummary';
import CardExtraContent from './CardExtraContent/CardExtraContent';
import CardExtraModal from './CardExtraModal/CardExtraModal';
import CardExtraGroup from './CardExtraGroup/CardExtraGroup';

export interface Props {
	type: ServiceType;
	filter?: CardExtraFilter;
	groupServices?: Pick<Props, 'filter'>[];
	insuranceCodes?: string[];
	variant?: CardExtraVariant;
	segmentId?: string;
}

const CardExtra: React.FC<Props> = props => {
	const { type, insuranceCodes, groupServices, variant } = props;

	const model = useCardExtra(props);

	if (!model.showService) {
		return null;
	}

	if (groupServices && groupServices.length > 1) {
		return (
			<CardExtraProvider value={model}>
				<CardExtraGroup groupServices={groupServices} />
			</CardExtraProvider>
		);
	}

	return (
		<CardExtraProvider value={model}>
			<CardExtraSummary>
				{summaryProps => (
					<CardExtraContent
						{...summaryProps}
						type={type}
						insuranceCodes={insuranceCodes}
						variant={variant}
						minPrice={model.cardExtraPrices.minPrice}
						totalPrice={model.cardExtraPrices.totalPrice}
						isConfirmed={model.isConfirmed}
						isReadonly={model.isReadonly}
						isLoading={model.isLoading}
						onChangeService={model.cardExtraDisclosure.onOpenModal}
						onToggleService={model.isSingleService ? model.onToggleService : null}
						onViewLoyaltyStatus={model.onViewLoyaltyStatus}
						additionalText={summaryProps.additionalText}
					/>
				)}
			</CardExtraSummary>

			<CardExtraModal
				openServiceType={model.cardExtraDisclosure.openServiceType}
				passengerPrices={model.cardExtraPrices.passengerPrices}
				isOpenModal={model.cardExtraDisclosure.isOpenModal}
				isDifferentPrices={model.cardExtraPrices.isDifferentPrices}
				onClose={model.cardExtraDisclosure.onCloseModal}
			/>
		</CardExtraProvider>
	);
};

export default CardExtra;
